module.exports = __webpack_public_path__ + "static/img/flowChart3.960f26da.jpg";